<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.title }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.title }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <template v-if="openedInModal">
        <UserDataEmployeeForm
                v-if="item"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations"
                :initial-values="retrieved" />
      </template>
      <template v-else>
        <b-row v-if="item">
          <b-col>
            <router-link v-if="item && prevRoute && prevRoute.name === 'UserDataShow'" :to="{ name: 'UserDataShow', params: { id: retrieved['@id'] }}" class="btn btn-default float-right">{{ $t('buttons.backToShow') }}</router-link>
            <router-link v-else :to="{ name: 'UserDataList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card>
              <div class="card-header">
                <h4 class="card-title">{{$t('views.userdata.update.title')}} {{ item && item['title'] }}</h4>
              </div>
              <div class="card-body">
                <b-row>
                  <b-col>
                    <UserDataEmployeeForm
                            v-if="item"
                            :handle-submit="onSendForm"
                            :handle-update-field="updateField"
                            :values="item"
                            :errors="violations"
                            :initial-values="retrieved" />
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserDataEmployeeForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    UserDataEmployeeForm,
    Loader
  },

  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  props: {
    userDataEmployeeId: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'userdataemployee/update/isLoading',
      error: 'userdataemployee/update/error',
      deleteError: 'userdataemployee/del/error',
      deleteLoading: 'userdataemployee/del/isLoading',
      created: 'userdataemployee/create/created',
      deleted: 'userdataemployee/del/deleted',
      retrieved: 'userdataemployee/update/retrieved',
      updated: 'userdataemployee/update/updated',
      violations: 'userdataemployee/update/violations'
    }),
    openedInModal: function (val) {
      if (this.routeName === 'FirmShow') {
        return true
      } else {
        return false
      }
    }
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'UserDataEmployeeList' })
    },
    updated: function (updated) {
      if (this.routeName === 'FirmShow') {
        // this.$Swal({
        //   title: this.$t('notifications.updated'),
        //   type: 'success'
        // })
        this.$store.state.modals.userdataemployee.update.updated = 1
        this.$store.state.modals.userdataemployee.update.close = 1
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.routeName = this.$route.name
    if (this.userDataEmployeeId) {
      this.retrieve(decodeURIComponent(this.userDataEmployeeId))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'userdataemployee/create/reset',
      deleteItem: 'userdataemployee/del/del',
      delReset: 'userdataemployee/del/reset',
      retrieve: 'userdataemployee/update/retrieve',
      updateReset: 'userdataemployee/update/reset',
      update: 'userdataemployee/update/update',
      updateRetrieved: 'userdataemployee/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this userdataemployee ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
